module.exports = __webpack_public_path__ + "static/img/1.e18303d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/1.png
// module id = 1uUz
// module chunks = 0